import * as React from "react";
import BaseModelMap from "../models/BaseModelMap";
import TemplateGroup from "../models/TemplateGroup";
import BaseDialog, { Field } from "./BaseDialog";
import { showToast } from "../components/Toasts";

import Logger from "../Logger";

const logger = new Logger();

export default function TemplateGroupDialog(props: { parent?: BaseModelMap<TemplateGroup>; obj?: TemplateGroup }) {
  const { parent, obj } = props;

  const [name, setName] = React.useState(obj?.name || getNewTemplateName());
  const edit = obj != undefined;

  if (!edit && parent == undefined) {
    logger.error("parent == undefined");
  }
  // check if name is already assingned
  function checkValidName(name: string): boolean {
    var double = false;

    parent?.items.forEach((TemplateGroup) => {
      if (state.noDoubleValue.ciEquals(TemplateGroup.name, name)) {
        double = true;
      }
    });

    return !double;
  }

  function getNewTemplateName(): string {
    var templateName = `${state.translate("components.TemplateGroup", "Template Gruppe ")}`;

    var i = 1;
    var newTemplateName = templateName + i;
    while (!checkValidName(newTemplateName)) {
      newTemplateName = templateName + i;
      i++;
    }

    return newTemplateName;
  }

  return (
    <BaseDialog
      title={
        edit
          ? state.translate("sceneGroupDialog.editSceneGroup", "Edit Templategruppe")
          : state.translate("sceneGroupDialog.createSceneGroup", "Neue Templategruppe")
      }
      onClose={() => {
        return true;
      }}
      onOk={() => {
        if (edit) {
          if (obj) {
            obj.name = name;
            obj.raiseOnChange();
          }
        } else {
          if (parent) {
            const newTemplateGroup = new TemplateGroup({ name: name });
            newTemplateGroup.parent = parent;
            parent.add(newTemplateGroup);
          }
        }
        return true;
      }}
    >
      <Field label={state.translate("name", "Name")}>
        <input
          className="input"
          maxLength={state.maxCharLimit.text}
          defaultValue={name}
          onChange={(ev) => {
            if (checkValidName(ev.target.value)) {
              setName(ev.target.value);
            } else {
              showToast({
                text: state.translate("dialog.nameAlreadyUsed", "leider ist ihr eingegebener Name schon vergeben"),
              });
            }
          }}
        ></input>
      </Field>
    </BaseDialog>
  );
}
